<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}">
        <div class="row">
            <div class="col-12">
                <validated-text-area label="Content" v-model="model.content" class="required-field"
                                     :rules="{required: true, max:500}" :disabled="loading"/>
            </div>
<!--            <div class="col-12">-->
<!--                <custom-file-input class="c-file-input" ref="file" label="Media" v-model="model.media"-->
<!--                                   :disabled="loading" placeholder="Upload Video" name="Media"-->
<!--                                   accept="video/mp4,video/x-m4v,video/*">-->
<!--                </custom-file-input>-->
<!--                &lt;!&ndash;                <image-info width1="1890" width2="1950" height1="490" height2="520"/>&ndash;&gt;-->
<!--            </div>-->

            <div class="col-12">

        <custom-file-input
          class="c-file-input"
          ref="file"
          label="Media"
          v-model="model.media"
          :disabled="loading"
          placeholder="Upload Video"
          name="Media"
          accept="video/mp4,video/x-m4v,video/*"
          @input="validateFile"
        >
        </custom-file-input>
        <p v-if="fileError" class="error-message">{{ fileError }}</p>
      </div>

            <div class="col-12">
                <file-input class="c-file-input" ref="file" label="Brochure" v-model="model.brochure"
                            :disabled="loading" name="Brochure">
                </file-input>
            </div>
            <div class="col-6">
                <validated-input type="number" label="Order" v-model="model.order"
                                 :rules="{required: false, min_value:1}" :disabled="loading"/>
            </div>
            <div class="col-6">
                <validated-checkbox label="Enabled" v-model="model.is_enabled"
                                    :rules="{required: false}" :disabled="loading"/>
            </div>
            <div class="col-12 text-right">
                <btn class="trn" text="Save" loading-text="Saving..." size="sm" :disabled="loading" :loading="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>

import urls from '../../../../data/urls';

export default {
    name: 'AddWhyChooseUs',

    data () {
        return {
            fileError: null,
            addUrl: urls.admin.whyChooseUs.addEdit
        };
    },

    methods: {
        validateFile (file) {
            this.fileError = null;
            if (file) {
                const actualFile = Array.isArray(file) ? file[0] : file;
                if (actualFile && actualFile instanceof File) {
                    const maxSizeInBytes = 60 * 1024 * 1024; // 10 MB in bytes

                    if (actualFile.size > maxSizeInBytes) {
                        this.fileError = 'File size exceeds 60MB. Please upload a smaller video.';
                        this.$emit('input', null); // Reset the v-model value
                    }
                } else {
                    console.error('Invalid file object:', actualFile);
                }
            }
        },
        formSuccess () {
            this.$notify('Successfully Added Item..!', 'Success',
                {
                    type: 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 0.9em;
  margin-top: 5px;
}
</style>
